module.exports = __webpack_public_path__ + "static/media/about-icon-individual.d7f480c9.svg";